var map = {
	"./finland.json": [
		68943,
		431
	],
	"./great_britain.json": [
		19880,
		909
	],
	"./norway.json": [
		24051,
		359
	],
	"./slovakia.json": [
		48842,
		446
	],
	"./spain.json": [
		2458,
		220
	],
	"./sweden.json": [
		70878,
		726
	],
	"./switzerland.json": [
		45999,
		961
	],
	"./tsvetkov_mountains.json": [
		1688,
		131
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 94955;
module.exports = webpackAsyncContext;